import { render, staticRenderFns } from "./DuwaProductinformation.vue?vue&type=template&id=bf856024"
import script from "./DuwaProductinformation.vue?vue&type=script&lang=js"
export * from "./DuwaProductinformation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports